import { p as proxyCustomElement, H, h } from './p-BJEvNVLM.js';

const CosmosMode = /*@__PURE__*/ proxyCustomElement(class CosmosMode extends H {
    constructor() {
        super();
        this.__registerHost();
        this.mode = 'light';
    }
    render() {
        return h("slot", { key: '08f987d76b31888d8910d862514d8a127ead711a' });
    }
    get element() { return this; }
}, [4, "cosmos-mode", {
        "mode": [513]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-mode"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-mode":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosMode);
            }
            break;
    } });
}

export { CosmosMode as C, defineCustomElement as d };
